var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8326_2152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9818 5.97537L15.9999 5.99449L13.9104 2.47489C13.8875 2.4363 13.846 2.4126 13.8011 2.4126H2.19874C2.15384 2.4126 2.11233 2.43629 2.08947 2.47489L0 6.01062V8.55982C0 8.62993 0.0568747 8.6868 0.126979 8.6868H0.414379V12.6193C0.414379 13.153 0.843445 13.5871 1.37078 13.5871H14.6292C15.1565 13.5871 15.5856 13.153 15.5856 12.6193V8.6868H15.873C15.9431 8.6868 16 8.62993 16 8.55982L15.9818 5.97537ZM2.27108 2.66657H13.7285L15.65 5.91271H0.350016L2.27108 2.66657ZM15.3315 12.6194C15.3315 13.013 15.0164 13.3332 14.629 13.3332H1.37063C0.983283 13.3332 0.668176 13.013 0.668176 12.6194V8.68684H5.66284V9.81991C5.66284 9.89001 5.71972 9.94689 5.78982 9.94689H10.2098C10.2799 9.94689 10.3368 9.89001 10.3368 9.81991V8.68684H15.3315L15.3315 12.6194ZM5.91682 9.69297V8.68688H10.0828V9.69297H5.91682ZM15.7459 8.43292H0.253883V6.16679H15.7459V8.43292Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8326_2152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarton);
export default __webpack_public_path__ + "static/media/carton.d269bfd92ca31221024f60b2f9253c7b.svg";
export { ForwardRef as ReactComponent };